import { Trans, useTranslation } from "react-i18next";
import ChartNoData from "components/charting/ChartNoData";
import { Bold } from ".";

function OneRepMaxChartNoDataNoExercise() {
  const { t } = useTranslation();

  return (
    <ChartNoData
      title={t("charting.one_rep_max_no_data_no_exercise_title")}
      description={
        <Trans i18nKey="charting.one_rep_max_no_data_no_exercise_description" components={{ 1: <Bold /> }} />
      }
    />
  );
}

export default OneRepMaxChartNoDataNoExercise;
